// extracted by mini-css-extract-plugin
export default {"headerContent":"Faq-module__headerContent___Rb1Om","content":"Faq-module__content___3jf_B"};